<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext';

    const { urlHelper } = getContainer();
</script>

<div>
    <h2 class="text-center">Inscription</h2>
    <div class="text-left">
        <p>
            Inscrivez-vous sur Go Africa pour bénéficier de tous nos service de mise en
            relation:
        </p>
        <ul class="list-none p-0">
            <li>Contacter des entreprises</li>
            <li>Faire des demandes de devis</li>
            <li>Laisser vos avis sur les professionnels</li>
        </ul>
        <p>
            L'inscription est <strong>rapide</strong> et <strong>gratuite</strong> alors
            <em>rejoignez nous !</em>
        </p>
    </div>
    <div>
        <div class="mt-[20px]" />
        <a href={urlHelper().registration()} class="btn btn-block btn-lg btn-yellow">
            Je crée mon compte
        </a>
    </div>
</div>
